export default __webpack_public_path__ + "static/Wiki_Tiles_P-IN-6001HD_white-f6ab1f6177152b4d45a7f73c23a1cb19.webp";